import http from 'hub-http/clients/apiClient';
const URI_FETCH = 'automationplatform/v1/flows';
export function fetchByUuids(uuids) {
  return http.post(`${URI_FETCH}/uuids/fetch`, {
    data: uuids
  });
}